import { render, staticRenderFns } from "./CardioTable.vue?vue&type=template&id=1e87a1f5&scoped=true&"
import script from "./CardioTable.vue?vue&type=script&lang=js&"
export * from "./CardioTable.vue?vue&type=script&lang=js&"
import style0 from "./CardioTable.vue?vue&type=style&index=0&id=1e87a1f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e87a1f5",
  null
  
)

export default component.exports